// extracted by mini-css-extract-plugin
module.exports = {"cp-modal-company__preview":"styles_cp-modal-company__preview__2vpKz"};